export const SET_SESSION_ID = 'session/SET_SESSION_ID'
export const SET_SESSION_LANGUAGE = 'session/SET_SESSION_LANGUAGE'
export const SET_SESSION_CURRENCY = 'session/SET_SESSION_CURRENCY'
export const START_SESSION_TIMER = 'session/START_SESSION_TIMER'
export const RESET_START_SESSION_TIMER = 'session/RESET_START_SESSION_TIMER'
export const SESSION_ID_STORAGE_KEY = `${process.env.REACT_APP_FLOW_CLIENT_ID}SessionId`
